import React__default from 'react';

const tableHeadHeading = "_table-head-heading_1toih_1";
const styles = {
	tableHeadHeading: tableHeadHeading
};

const TableHeadHeading = (props) => {
  return React__default.createElement("span", { className: styles.tableHeadHeading }, props.children);
};

export { TableHeadHeading };
//# sourceMappingURL=TableHeadHeading.es.js.map
